import getCaps from '@anm/data/streaming/destinationsCaps';
import getDestinationExpireDate from '@anm/helpers/stream/getDestinationExpireDate';
import isDestinationDisconnected from '@anm/helpers/stream/isDestinationDisconnected';
import { SocialDestination } from 'types/stream';

export type DestinationWithWarning = SocialDestination & {
  daysToExpire?: number;
  hoursToExpire?: number;
};

// TWITCH/RTMP/AmazonLive destinations can't be broken by expiresOn, ommit them
// have error or can expire and already expired -> error
// can expire and expire in <= 1 hour -> error
// if not in errors list, not TWITCH, not RTMP and expire soon - warning with days
// if warning but less then 1 day to expire => warning with hours

const getBrokenDestinations = (list?: SocialDestination[]) => {
  const destinationsWithError = list?.filter(d => isDestinationDisconnected(d));

  const destinationWithWarning: DestinationWithWarning[] | undefined = list
    ?.filter(
      d =>
        !destinationsWithError?.includes(d) &&
        getDestinationExpireDate(d.expiresOn)?.isWarning &&
        d.network && !getCaps(d.network, d.kind)?.tokenDoesNotExpire
    )
    .map(d => {
      const expireData = getDestinationExpireDate(d.expiresOn);

      const daysToExpire = expireData?.daysToExpire;
      const hoursToExpire = expireData?.hoursToExpire;
      const canShowHours = typeof daysToExpire === 'number' && daysToExpire <= 1;

      return {
        ...d,
        ...(canShowHours ? { hoursToExpire } : { daysToExpire })
      };
    });

  return [destinationsWithError, destinationWithWarning] as const;
};

export default getBrokenDestinations;
